/**
 * emailDeliveryRecipientHealthApi
 *
 * DASH-EMAIL-007: client for the real, read-only RECIPIENT-grain
 * Dashboard API (`GET /api/email-delivery/dashboard/recipient-health`).
 *
 * Distinct entity grain from emailDeliveryDashboardApi.js's MESSAGE-grain
 * `/summary` endpoint -- this module must never be used to fetch or
 * substitute for a message-level metric (delivered/bounced/dropped/etc),
 * and `/summary`'s client must never be used for a recipient-health
 * metric. See email_delivery_recipient_health_service.py's own docstring
 * for the canonical-source rule this pairing enforces.
 *
 * Wraps the SAME shared `api` axios instance every other real-backed War
 * Room surface already uses (see lib/api.js, emailDeliveryDashboardApi.js)
 * -- no second HTTP stack, no collection name ever appears here or in any
 * caller. Auth (Bearer token) and account scoping (X-Account-ID header)
 * are attached automatically by that instance's own request interceptor;
 * this module never accepts or forwards a caller-supplied account/tenant
 * id.
 *
 * `environment`, if supplied, must be exactly "qualification" or
 * "production" -- the real SendGridEnvironment values the backend query
 * parameter is typed against. Omitting it (or passing "all"/undefined)
 * fetches the unfiltered, all-environments count for this account.
 */
import { api } from "./api";

export async function getEmailDeliveryRecipientHealth({ environment } = {}) {
  const params = {};
  if (environment && environment !== "all") {
    params.environment = environment;
  }
  const res = await api.get("/email-delivery/dashboard/recipient-health", { params });
  return res.data;
}

export default getEmailDeliveryRecipientHealth;
